export default __webpack_public_path__ + "static/poolsvision-43d8fa72599549910831c661c54050df.jpg";